import gql from "graphql-tag";

const WaterlowProps = gql`
    fragment WaterlowProps on WaterlowPressureUlcer {
        id
        sex
        age
        skin
        bmiRange
        malNutrition {
            a
            b
            c
        }
        continence
        mobility
        specialRisk {
            major
            medication
            tissue
            neurology
        }
        confirm {
            status
            author {
                id
                surname
                first_name
                middle_name
                designation {
                    id
                    name
                }
            }
            datetime
        }
        author {
            id
            surname
            first_name
            middle_name
            designation {
                id
                name
            }
        }
        created_at
    }
`;

export const GET_WATERLOW_LIST = gql`
    query GetWaterlowList($id: ID!) {
        GetWaterlowPressureUlcerAssessments(id: $id) {
            message
            docs {
                ...WaterlowProps
            }
        }
    }
    ${WaterlowProps}
`;

export const NEW_WATERLOW = gql`
    mutation NewWaterlow($model: InputWaterlowPressureUlcer!, $confirm: Boolean!) {
        NewWaterlowPressureUlcerAssessment(model: $model, confirmed: $confirm) {
            message
            doc {
                ...WaterlowProps
            }
        }
    }
    ${WaterlowProps}
`;

export const CONFIRM_WATERLOW = gql`
    mutation ConfirmWaterlow($id: ID!) {
        ConfirmWaterlowPressureUlcer(id: $id) {
            message
            doc {
                ...WaterlowProps
            }
        }
    }
    ${WaterlowProps}
`;
